import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { EventItem, toEventItemXml } from '../../dataObjects/EventItem';

export interface IUpdateEventRequest extends IBaseRequest {
    ITEM: EventItem;
}

export class UpdateEventRequest extends BaseRequest implements IUpdateEventRequest {
    public ITEM: EventItem;
  constructor(server: string, session: string, item: EventItem) {
    super(server, session);
    this.ITEM = item;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += '<ITEM>';
    parameters += toEventItemXml(this.ITEM);
    parameters += '</ITEM>';
    return super.wrapperXml('UpdateEvent', parameters);
  }
}
